import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportProposalDetailPageRoutingModule } from './report-proposal-detail-routing.module';

import { ReportProposalDetailPage } from './report-proposal-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportProposalDetailPageRoutingModule
  ],
  declarations: [ReportProposalDetailPage]
})
export class ReportProposalDetailPageModule {}
